import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { IClientSettings, User } from "appz";
import { ApplicationState } from "store";

let reactPlugin: any = null;
let appInsights: any = null;

/**
 * Create the App Insights Telemetry Service
 * @return {{reactPlugin: ReactPlugin, appInsights: Object, initialize: Function}} - Object
 */
const createTelemetryService = () => {
    /**
     * Initialize the Application Insights class
     * @param {string} instrumentationKey - Application Insights Instrumentation Key
     * @param {Object} browserHistory - client's browser history, supplied by the withRouter HOC
     * @return {void}
     */
    const initialize = (
        browserHistory: any,
        clientSettings: IClientSettings,
        initialState: ApplicationState,
    ) => {
        if (!browserHistory) {
            throw new Error("BrowserHistory not provided.");
        }

        const aiKey = clientSettings && clientSettings.aiInstrumentationKey;

        if (!aiKey) {
            throw new Error("Instrumentation key not provided.");
        }

        const id = initialState && initialState.user && initialState.user.id;

        reactPlugin = new ReactPlugin();

        appInsights = new ApplicationInsights({
            config: {
                instrumentationKey: aiKey,
                accountId: id,
                maxBatchInterval: 0,
                disableFetchTracking: false,
                enableAutoRouteTracking: true,
                extensions: [reactPlugin],
                extensionConfig: {
                    [reactPlugin.identifier]: {
                        history: browserHistory,
                    },
                },
            },
        });

        appInsights.loadAppInsights();

        var telemetryInitializer = (envelope: any) => {
            envelope.data.initialState = initialState;
        };

        appInsights.addTelemetryInitializer(telemetryInitializer);
    };

    return { reactPlugin, appInsights, initialize };
};

export const ai = createTelemetryService();
export const getAppInsights = () => appInsights;
